// extracted by mini-css-extract-plugin
module.exports = {"camp_index_tabs":"camp_index_tabs___MhC6V"};